export const EVENTS = {
  VDNH: 'vdnh',
  AVELEKS: 'aveleks',
  CHRONICLES: 'chronicles',
  RUSSIA: 'rissia',
  ATOM: 'atom',
}